import { useContext } from "react";
import { CollectionsContext } from "../../../components/root/CollectionsProvider";

type CategoryChoice = { value: string; text: string };

export const useNoteCategoryChoices = () => {
	const collections = useContext(CollectionsContext);
	const categoryField = collections?.fields.find((f) => f.collection === "notes" && f.field === "category") as any;
	return (categoryField?.meta?.options?.choices ?? []) as Array<CategoryChoice>;
};
